import videojs from 'video.js';
const Button = videojs.getComponent('Button');
class CloseSettingsMenuButton extends Button {
    constructor(player, options, handleUpdate) {
        super(player, options);
        this.on('click', () => {
            handleUpdate();
        });
        this.on('tap', () => {
            handleUpdate();
        });
        this.setAttribute('label', 'close menu');
    }
}
export default CloseSettingsMenuButton;
//# sourceMappingURL=CloseSettingsMenuButton.js.map